export default __webpack_public_path__ + "static/media/ey-logo.c3cb8cd9.svg";